import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';

import { fetchDrivers } from '../../actions/driver';
import FieldTextArea from './FieldTextArea.jsx';
import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';
import FieldRatingSelfSubmit from './FieldRatingSelfSubmit.jsx';
import FieldSelectWithOther from './FieldSelectWithOther.jsx';
import FieldTextBox from './FieldTextBox.jsx';
import FieldDateRange from './FieldDateRange.jsx';

const overrideOptions = [
  { slug: 1, value: '1 - Poor' },
  { slug: 2, value: '2 - Below Average' },
  { slug: 3, value: '3 - Average' },
  { slug: 4, value: '4 - Above Average' },
  { slug: 5, value: '5 - Exceptional' },
];

export class Training extends React.Component {
  constructor(props) {
    super(props);

    this.fields = {
      mistakes: {
        label: 'Mistakes',
        description: 'What mistakes were made as a driver?',
        field: 'mistakes',
      },
      positive: {
        label: 'Positive',
        description: 'What were the positive moments as a driver?',
        field: 'positive',
      },
      ratings: [
        {
          label: 'Self-Preparation',
          description: 'Your preparation for sessions: communication, readiness, timeliness, etc.',
          field: 'selfPreparation',
        },
        {
          label: 'Effort',
          description: 'Evaluate your overall effort during the training sessions',
          field: 'effort',
        },
        {
          label: 'Trainer Preparation',
          description: 'Trainer\'s preparation for sessions: organization, readiness, timeliness, etc.',
          field: 'trainerPreparation',
        },
        {
          label: 'Trainer Emotional Support',
          description: 'How trainer was emotionally supportive: attitude, focus, etc.',
          field: 'trainerEmotionalSupport',
        },
      ],
    };
  }

  componentDidMount() {
    this.props.fetchDrivers();
  }

  isValidForm(fields) {
    return (
      _.castArray(fields.dateRange).length === 2
      && !_.isEmpty(fields.driverName)
      && !_.isEmpty(fields.trainingSessionsCompleted)
    );
  }

  render() {
    return (
      <form id="self-ratings-training-form" autoComplete="off">
        <h3>TRD Driver Self Rating - Training</h3>
        <Row>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={this.props.drivers}
              defaultEmptyOption="Driver Name *"
              field="driverName"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldDateRange />
          </Col>
          <Col xs={12} sm={4}>
            <FieldTextBox placeholder="Training Sessions Completed" field="trainingSessionsCompleted" />
          </Col>
        </Row>

        <div id="section-practice-details">
          <h4 className="rating-type">Reflection</h4>
          <p className="subtext">All information given is confidential and will not be shared outside TRD.</p>
          <Row>
            {this.fields.ratings.map((question, i) => (
              <Col sm={6} xs={12} key={question.field}>
                <FieldTextAreaWithRating
                  label={`${(i + 1)}) ${question.label}`}
                  description={(question.description) ? `${question.description}` : null}
                  ratingField={`${question.field}.rating`}
                  textAreaField={`${question.field}.feedback`}
                  placeholder="Feedback"
                  nonTrackRating={true}
                  overrideOptions={overrideOptions}
                  overrideDefaultValue={5}
                />
              </Col>
            ))}
          </Row>

          <Row>
            <Col xs={12}>
              <h6 className="pad">
                5) Improvements
                <small>
                  <br />(What improvements can be made to increase the effectiveness of your training?)
                </small>
              </h6>
              <FieldTextArea
                field="improvements"
                placeholder="Feedback"
              />
            </Col>
          </Row>

          <div className="form-submit-wrapper">
            <div className="pull-right">
              <FieldRatingSelfSubmit formType="training" isValidForm={this.isValidForm} />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export const mapStateToProps = state => ({
  formType: state.form.formType,
  drivers: state.driver.result || [],
});

export default connect(
  mapStateToProps,
  { fetchDrivers },
)(Training);
